import React, { useRef, useState, useEffect } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space, Table, Modal } from 'antd';
import Highlighter from 'react-highlight-words';
import { useNavigate } from 'react-router-dom';
import { getCartable } from 'api/cartableservice';
import { Center } from '@chakra-ui/react';

// داده تستی موقتی
// const data = [
//   {
//     id: '1',
//     title: 'Cancer Research',
//     author: 'Dr. Smith',
//     journal: 'Medical Times',
//     status: 'Approved',
//     role: 'Reviewer',
//     description: 'Reviewed for ethics',
//     date: '2025-04-10'
//   },
//   {
//     id: '2',
//     title: 'Heart Health',
//     author: 'Dr. John',
//     journal: 'Cardio Journal',
//     status: 'Pending',
//     role: 'Editor',
//     description: 'Needs revision',
//     date: '2025-03-25'
//   }
// ];

const CartableTable = () => {

  function stripHtml(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value.replace(/<[^>]+>/g, '');
  }
  const [data, setData] = useState([]);
  const [isMount, setIsMount] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState();
  const [pageSize, setPageSize] = useState();
  const [totalCount, setTotalCount] = useState();

  useEffect(() => {

    if (isMount) {
      setLoading(true);
      getCartable(page, pageSize).then((result) => {
        const safeData = Array.isArray(result)
          ? result
          : Array.isArray(result?.data)
            ? result.data
            : [];
        setTotalCount(result?.meta?.total);
        const mappedData = safeData.map((item) => ({
          id: item.id,
          title: item.articleTitle ? stripHtml(item.articleTitle) : '',
          author: item.authorName, // نویسنده
          senderEmail: item.senderEmail, //ایمیل نویسنده
          journal: item.journalName, // ژورنال
          status: item.statusTitle, // وضعیت
          role: item.role, // نقش
          description: item.description ? stripHtml(item.description) : '',
          date: item.createdDate ? item.createdDate.split("T")[0] : '', // تاریخ ایجاد
          actions: item.actions,
          code: item.articleCode
        }));
        setData(mappedData);
      })
        .finally(() => {
          setLoading(false); // پایان لودینگ (چه موفق، چه خطا)
        });

    }
  }, [isMount, page, pageSize]);


  useEffect(() => {
    setIsMount(true)
    // console.log("data updated:", data);
  }, [])

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const navigate = useNavigate();

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
  };
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button type="link" size="small" onClick={() => close()}>
            Close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });


  const handleActionClick = (event, record) => {
    navigate(`./article_actions/${record.id}`);

  };

  const columns = [

    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      width: '15%',
      align: 'center',
      ...getColumnSearchProps('code'),

    },
    {
      title: 'Article Title',
      dataIndex: 'title',
      key: 'title',
      width: '25%',
      ...getColumnSearchProps('title'),

    },
    {
      title: 'Sender',
      dataIndex: 'author',
      key: 'author',
      width: '15%',
      ...getColumnSearchProps('author'),

    },
    {
      title: 'Sender Email',
      dataIndex: 'senderEmail',
      key: 'senderEmail',
      width: '15%',
      ...getColumnSearchProps('senderEmail'),

    },
    {
      title: 'Journal',
      dataIndex: 'journal',
      key: 'journal',
      width: '10%',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: '10%',
      align: 'center',
      ...getColumnSearchProps('status'),
      render: (text) => (
        <div style={{ textAlign: 'center' }}>
          {text}
        </div>
      ),
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      width: '10%',
      align: 'center',
    },
    // {
    //   title: 'Description',
    //   dataIndex: 'description',
    //   key: 'description',
    //   width: '15%',
    // },
    {
      title: 'Action',
      key: 'action',
      width: '10%',
      align: 'center',
      render: (_, record) => (
        <Button type="link" onClick={(e) => handleActionClick(e, record)}><b>Actions</b></Button>
      )
    },
    {
      title: <span style={{ whiteSpace: 'nowrap' }}>Create Date</span>,
      dataIndex: 'date',
      key: 'date',
      width: '18%',
      align: 'center',
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      sortDirections: ['descend', 'ascend'],
    }

  ];

  return (
    <>
      <Table
        className='custom-centered-header'
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey="id"
        onRow={(record) => ({
          style: { cursor: 'pointer' },
        })}
        rowClassName={() => 'custom-row-hover'}
        pagination={{
          current: page,
          pageSize: pageSize,
          total: totalCount,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} articles`,
        }}
        onChange={handleTableChange}
      />

    </>
  );


};

export default CartableTable;
